<template>
    <BasePanel
        headline='lang_GENERIC_AZ_PANEL_CAPTION_MAPPINGS'
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-row class="pt-4">
                <!-- Publishing statements -->
                <v-col cols="3">
                    <v-row class="pb-3 headline">
                        <div class="headline mx-4">
                            {{ $t('lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_STATEMENTS') }}
                        </div>
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown
                            :context="context"
                            field="PublishingSummaryMapping"
                            :items="publishingStatementsMappings"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_SUMMARY_MAPPING')"
                            :resetValNull="true"
                            :alvqa="alvqa + '-dropdown-publishing-summary-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown
                            :context="context"
                            field="PublishingDetailsMapping"
                            :items="publishingStatementsMappings"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_DETAILS_MAPPING')"
                            :resetValNull="true"
                            :alvqa="alvqa + '-dropdown-publishing-details-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown
                            :context="context"
                            field="PublishingPerWorkMapping"
                            :items="publishingStatementsMappings"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_PER_WORK_MAPPING')"
                            :resetValNull="true"
                            :alvqa="alvqa + '-dropdown-publishing-per-work-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown
                            :context="context"
                            field="PublishingProjectsSheetsMapping"
                            :items="publishingStatementsMappings"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_PROJECTS_SHEETS_MAPPING')"
                            :resetValNull="true"
                            :alvqa="alvqa + '-dropdown-publishing-projects-sheets-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown
                            :context="context"
                            field="PublishingTop10Mapping"
                            :items="publishingStatementsMappings"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_TOP_10_MAPPING')"
                            :resetValNull="true"
                            :alvqa="alvqa + '-dropdown-publishing-top-10-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown
                            :context="context"
                            field="PublishingPayeeMapping"
                            :items="publishingPayeeStatementMappings"
                            :label="$t('lang_GENERIC_AZ_CAPTION_PUBLISHING_PAYEE_MAPPING')"
                            :resetValNull="true"
                            :alvqa="alvqa + '-dropdown-publishing-payee-mapping'"
                        />
                    </v-row>
                </v-col>

                <!-- Label statements -->
                <v-col cols="3">
                    <v-row class="pb-3 headline">
                        <div class="headline mx-4">
                            {{ $t('lang_GENERIC_CAPTION_INTERESTS_LABEL_ROYALTY_STATEMENTS') }}
                        </div>
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown
                            :context="context"
                            field="LabelDigitalMapping"
                            :items="labelStatementsMappings"
                            :label="$t('lang_GENERIC_AZ_CAPTION_LABEL_DIGITAL_MAPPING')"
                            :resetValNull="true"
                            :alvqa="alvqa + '-dropdown-label-digital-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown
                            :context="context"
                            field="LabelRetailMapping"
                            :items="labelStatementsMappings"
                            :label="$t('lang_GENERIC_AZ_CAPTION_LABEL_RETAIL_MAPPING')"
                            :resetValNull="true"
                            :alvqa="alvqa + '-dropdown-label-retail-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown
                            :context="context"
                            field="LabelLicenseMapping"
                            :items="labelStatementsMappings"
                            :label="$t('lang_GENERIC_AZ_CAPTION_LABEL_LICENSE_MAPPING')"
                            :resetValNull="true"
                            :alvqa="alvqa + '-dropdown-label-license-mapping'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown
                            :context="context"
                            field="LabelPerReleaseMapping"
                            :items="labelStatementsMappings"
                            :label="$te('lang_GENERIC_AZ_CAPTION_LABEL_PER_RELEASE_MAPPING') ? $t('lang_GENERIC_AZ_CAPTION_LABEL_PER_RELEASE_MAPPING') : 'Statement per release (Label)'"
                            :resetValNull="true"
                            :alvqa="alvqa + '-dropdown-label-per-release-mapping'"
                        />
                    </v-row>
                </v-col>
            </v-row>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "AzPersonsMappingsPanel",
    components: {
        BasePanel,
        BaseEditPageDropdown,
    },
    data() {
        return {
            context: "AzPersonsMetadata",
            alvqa: "az-persons-edit-form-panel-mappings",
            publishingStatementsMappings: [],
            publishingPayeeStatementMappings: [],
            labelStatementsMappings: []
        }
    },
    methods: {
        async getStatementMappings() {
            this.$store.commit('setSelectedMappingsDomainsFilter', ['publishing_statements', 'publishing_payee_statement', 'label_statements'])
            this.$store.commit('setSelectedMappingsDirectionsFilter', 'export')
            await this.$store.dispatch('fetchMappingsByDomain')

            let mappingsList = this.$store.getters.getMappings
            this.publishingStatementsMappings = []
            this.publishingPayeeStatementMappings = []
            this.labelStatementsMappings = []
            mappingsList.forEach((v) => {
                if (v.direction !== 'export') return;

                if (v.domain === 'label_statements') {
                    this.labelStatementsMappings.push({
                        value: v.alvId,
                        text: v.abbreviation,
                        alvqa: this.alvqa + `-export-mapping-${v.alvId}`
                    })
                } else if (v.domain === 'publishing_statements') {
                    this.publishingStatementsMappings.push({
                        value: v.alvId,
                        text: v.abbreviation,
                        alvqa: this.alvqa + `-export-mapping-${v.alvId}`
                    })
                } else if (v.domain === 'publishing_payee_statement') {
                    this.publishingPayeeStatementMappings.push({
                        value: v.alvId,
                        text: v.abbreviation,
                        alvqa: this.alvqa + `-export-mapping-${v.alvId}`
                    })
                }
            })

            this.$store.commit('setSelectedMappingsDirectionsFilter', null)
        }
    },
    created() {
        this.getStatementMappings()
    }
}
</script>
